module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "funtime"
  }, [_c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("我是标题啊啊啊我是标题啊啊啊我是标题啊啊啊我是标题啊啊啊我是标题啊啊啊\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "publishtime"
  }, [_vm._v("2017-03-23 17:00")]), _vm._v(" "), _c('div', {
    staticClass: "detail-body",
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  })]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment"
  }, [_c('div', {
    staticClass: "comment-title"
  }, [_c('span', [_vm._v("留言")])]), _vm._v(" "), _c('ul', {
    staticClass: "ui-list"
  }, [_c('li', {
    staticClass: "ui-border-t"
  }, [_c('div', {
    staticClass: "ui-head"
  }, [_c('span', {
    staticStyle: {
      "background-image": "url(http://placeholder.qiniudn.com/100x100)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui-list-info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("我是用户名称")]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v("我是时间")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v("回复"), _c('label', {
    staticStyle: {
      "color": "#ffc001"
    }
  }, [_vm._v("丁立")]), _vm._v("：")]), _vm._v("我是评论我是评论我是评论我是评论我是评论我是评论我是评论我是评论我是评论我是评论我是评论我是评论我是评论我是评论我是评论")])])]), _vm._v(" "), _c('li', {
    staticClass: "ui-border-t"
  }, [_c('div', {
    staticClass: "ui-avatar"
  }, [_c('span', {
    staticStyle: {
      "background-image": "url(http://placeholder.qiniudn.com/100x100)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui-list-info"
  }, [_c('h4', {
    staticClass: "ui-nowrap"
  }, [_vm._v("这是标题，加ui-nowrap可以超出长度截断")]), _vm._v(" "), _c('p', {
    staticClass: "ui-nowrap"
  }, [_vm._v("这是内容，加ui-nowrap可以超出长度截断")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fd2ca74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/funTime.vue
// module id = 229
// module chunks = 1